/* eslint-disable max-len */
import { checkDateIsInSamePeriod } from 'app/utils/checkDateIsInSamePeriod';

const PAGE = 'hits';


export const allDishes = [
    25, 3214, 3960, 3513, 668, 58, 3612, 204, 7, 3843, 3723, 1924,
].map((id) => String(id));

const dishesData = allDishes.reduce((acc, id, index) => {
    const dishData = {
        id,
        orderNumber: index + 1,
    };
    return {
        ...acc,
        [id]: dishData,
    };
}, {});


export default {
    pageId: PAGE,
    pathSegment: PAGE,
    pathSegmentEn: PAGE,

    title: 'Рецепты Хиты — закажите самые популярные блюда Elementaree',
    description: 'Начните знакомство с этих блюд: самые популярные рецепты, которые не оставят равнодушными',

    ogImage: '',
    additionalContent: '',
    onInit: () => { },
    appConfig: {
        pageId: PAGE,
        city: null,
        period: null,
        firstPeriodStart: '2023-05-01',
        filterByIds: allDishes,

        areAvaliableDishesPersistentForPeriods: false,

        joinDishTitlesinMobile: false,
        dishesData,
        dishCategories: {
            main: {
                id: 'main',
                title: 'Наши хиты',
                titleEn: 'Наши хиты',
                detailsTitle: 'Наши хиты',
                description: [],
                enabledDishes: allDishes,
            },
        },
        canChangePortionsCount: true,
        areDetailsEnabled: true,

        enabledBasketDishIds: [],
        autoFillingBasket: false,

        isCheckoutEnabled: true,
        isLinkToMenuEnabled: true,

        prepareDates: (dates, periodsConfig = null, period = null, basketDishesIds) => dates.filter((d) => checkDateIsInSamePeriod(d.date, period)),

        prepareIntervals: null,

        ageGate: false,
        openBasketButtonType: 'scrollToCheckout',
        ageGateImage: null,
    },
};
